import React from 'react';
import { StepProps } from '@/types/broker-registration.types';
import { FormField } from '../FormField';
import { useLanguage } from '@/contexts/LanguageContext';
import { Checkbox } from '@/components/ui/checkbox';
import { ExternalLink } from 'lucide-react';

export function StepFive({ formData, updateFormData, errors, clearError }: StepProps) {
  const { language } = useLanguage();

  const translations = {
    en: {
      stepTitle: "Step 5: Terms & Conditions",
      termsLabel: "Terms and Conditions",
      viewFullTerms: "View Full Terms & Conditions",
      termsDescription: "Please read and accept our Terms and Conditions before proceeding.",
      acceptTerms: "I have read and accept the Terms and Conditions of AcquizGroup, including Annex C specific to Brokers.",
      required: "This field is required"
    },
    fr: {
      stepTitle: "Étape 5 : Termes et Conditions",
      termsLabel: "Termes et Conditions",
      viewFullTerms: "Voir les Termes et Conditions complets",
      termsDescription: "Veuillez lire et accepter nos Termes et Conditions avant de continuer.",
      acceptTerms: "J'ai lu et j'accepte les Termes et Conditions d'AcquizGroup, incluant l'Annexe C spécifique aux Courtiers.",
      required: "Ce champ est requis"
    }
  };

  const t = translations[language];

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-[#1D314D]">{t.stepTitle}</h2>
        <p className="text-gray-600 mt-2">{t.termsDescription}</p>
      </div>

      {/* Link to Full Terms */}
      <div className="bg-slate-50 border border-slate-200 rounded-lg p-6">
        <FormField label={t.termsLabel} required>
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-3 bg-[#2C3E50] text-white rounded-lg hover:bg-[#1D314D] transition-colors font-medium"
          >
            {t.viewFullTerms}
            <ExternalLink size={18} />
          </a>
        </FormField>
      </div>

      {/* Terms Acceptance Checkbox */}
      <FormField label="" error={errors.termsAccepted}>
        <div className="bg-white border border-slate-200 rounded-lg p-4">
          <label className="flex items-start gap-3 cursor-pointer">
            <Checkbox
              id="termsAccepted"
              checked={formData.termsAccepted}
              onCheckedChange={(checked) => {
                updateFormData({ termsAccepted: !!checked });
                clearError('termsAccepted');
              }}
              className="mt-1"
            />
            <span className="text-sm text-gray-700 leading-relaxed">
              {t.acceptTerms}
            </span>
          </label>
        </div>
      </FormField>

    </div>
  );
}
